import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { LocalesModule } from '../../modelo/locales/locales.module';
import { ventaLocalModule } from '../../modelo/usuario/ventaLocal';
import { LoginService } from '../../servicios/login.service';
import { ReporteService } from '../../servicios/reporte.service';
import { ReportVentasxLocalComponent } from '../report-ventasx-local/report-ventasx-local.component';

@Component({
  selector: 'app-report-devolucionx-local',
  templateUrl: './report-devolucionx-local.component.html',
  styleUrls: ['./report-devolucionx-local.component.css']
})
export class ReportDevolucionxLocalComponent implements OnInit {
  alertService: any;
  anios: [];
  tipo: [];
  meses: [];
  mesesMostrar: [];
  anioselec: string;
  categoria: string;
  listaLocales:LocalesModule[];
  usuario: string;
  id:string;
  id_pais: string;
  meseSelec: string[];
  aniosselec:string[];
  datosVentas: ventaLocalModule[];
  datosDevolucion: ventaLocalModule[];
  totalVenta1:number;
  totalDevolucion1:number;
  totalPorDev1:number;
  totalVenta2:number;
  totalDevolucion2:number;
  totalPorDev2:number;
  tipoSelec: []=[] as any;
  local:string;
  habilitar:boolean;
  mesesAnio = [
    { id: 1, name: 'Enero' },
    { id: 2, name: 'Febrero' },
    { id: 3, name: 'Marzo' },
    { id: 4, name: 'Abril' },
    { id: 5, name: 'Mayo' },
    { id: 6, name: 'Junio' },
    { id: 7, name: 'Julio' },
    { id: 8, name: 'Agosto' },
    { id: 9, name: 'Septiembre' },
    { id: 10, name: 'Octubre' },
    { id: 11, name: 'Noviembre' },
    { id: 12, name: 'Diciembre' },
  ];

  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;

  @ViewChild(MdbTablePaginationComponent) mdbTablePaginationD: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTableD: MdbTableDirective;

  constructor(private api: ReporteService,private apiLogin: LoginService) { }




public  cargarLocales(){
  this.apiLogin.locales(localStorage.getItem("id_pais"))
  .subscribe((
    data: LocalesModule[]) => {
    this.listaLocales = data;
    this.usuario=localStorage.getItem("nombre");
    this.local=localStorage.getItem("nombreLocal");
    this.id=localStorage.getItem("local");
    if (localStorage.getItem("rol")=='MaxiPan' || localStorage.getItem("rol")=='Gerencia CF' )
  {     this.habilitar=false;
  }else{
   this.habilitar=true;
  }
   console.log(this.listaLocales);
   this.listaLocales.forEach(item => {
    if (item.id.toString() ==this.id){
      localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
    }
    
  });
  },
 // err =>  this.alertService.danger('Error no hay  conexion..')
  );
}



onChangeLocal($event: Event) {
  
  localStorage.setItem('id', this.id);
  this.listaLocales.forEach(item => {
    if (item.id.toString() ==this.id){
      localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
      this.usuario=localStorage.getItem('nombre');
    this.local=localStorage.getItem('nombreLocal');
    }
    
  });

  this.id_pais=localStorage.getItem("id_pais");
    this.tipoSelec = [];
    //this.meseSelec=[];
   // this.aniosselec=[];
    this.listarAnioxLocal();
    this.local=localStorage.getItem("nombreLocal");
    
  //this.ngOnInit();
  }
  ngOnInit(): void {
    this.id_pais=localStorage.getItem("id_pais");
    this.tipoSelec = [];
    this.meseSelec=[];
    this.aniosselec=[];
    this.listarAnioxLocal();
    this.local=localStorage.getItem("nombreLocal");
   this.cargarLocales();

  }



fieldsChangeTipoCliente(ev): void {

  if(ev.target.checked){
  //this.tipoSelec.push(ev.target.defaultValue)
 // this.listarVenta();
  //this.listarDevolucion();
}else {
  const index: number = this.tipoSelec.indexOf(ev.target.defaultValue as never);
  if (index !== -1) {
    this.tipoSelec.splice(index, 1);

  }
  //this.listarVenta();
  //this.listarDevolucion();

}
}

  listarMesesVendidos(anio: string){
    this.mesesMostrar =[];
    this.mesesAnio.forEach(element => {
        this.mesesMostrar.push(element as never);
      });

      /*

    this.mesesMostrar = [];
    this.api.mesesDE( anio).subscribe((
      data: []) => {
      this.meses = data;
      this.meses.forEach(mes => {
        this.mesesAnio.forEach(element => {
          if (element.id == mes[0]) {
         //   this.mesesMostrar.push(element);
          }
        });
  
      });
  
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
    console.log(this.mesesMostrar);
    */
  }

  fieldsChange(ev): void {
    if(ev.target.checked){
      this.aniosselec.push(ev.target.defaultValue);
       }else{
         const index: number =this.aniosselec.indexOf(ev.target.defaultValue);
         if (index !== -1) {
           this.aniosselec.splice(index, 1);
        
       }  
       }

    this.listarMesesVendidos(ev.target.defaultValue)
    //this.listarVenta();
    //this.listarDevolucion();
  

      
    } 


    fieldsChangeMes(ev): void {

      if(ev.target.checked){
      this.meseSelec.push(ev.target.defaultValue);
      //this.listarVenta();
      //this.listarDevolucion();
    }else {
      const index: number = this.meseSelec.indexOf(ev.target.defaultValue);
      if (index !== -1) {
        this.meseSelec.splice(index, 1);
    
      }
      //this.listarVenta();
      //this.listarDevolucion();
    }

  }

  buscar(){

    this.listarVenta();
    this.listarDevolucion();
  }
listarAnioxLocal(){
  if (this.aniosselec.length==0){
  this.api.anioDE(localStorage.getItem("nombreLocal"),this.id_pais).subscribe((
    data: []) => {
    this.anios = data;
    console.log(this.anios);
    //this.listarVenta();
    //this.listarDevolucion();
  },
    err => this.alertService.danger('Error no hay  conexion..')
  );
}
}
listarVenta(){

  let meses = "";
  let ani="";
  let tipoDatos = "";
  let productos = "";
  this.meseSelec.forEach(element => {
    meses = meses + element + ",";
  });

  this.aniosselec.forEach(element => {
    ani = ani + element + ",";
  });

  this.tipoSelec.forEach(element => {
    tipoDatos = tipoDatos + "'"+element + "',";
  });


  if (meses.length > 0) {
    meses = meses + '0';
  } else {
    meses = "''"
  }

  if (ani.length > 0) {
    ani = ani + '0';
  } else {
    ani = "NO"
  }


  if (tipoDatos.length > 0) {
    tipoDatos = tipoDatos + "'0'"
  } else {
    tipoDatos = "NO"
  }
  this.totalVenta1=0;
  this.totalDevolucion1=0;
  this.totalPorDev1=0;
  this.api.Devolucion(ani, meses, tipoDatos,localStorage.getItem("nombreLocal").substring(0,4),this.id_pais).subscribe((
    data: []) => {
    this.datosVentas = data;
    let porcentaje=0.0;  
    this.datosVentas.forEach(element => {
    if  (element.venta>0){
        porcentaje=(element.devolucion/element.venta)*100
      }else{
        porcentaje=0;
      }
      let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
       if (valor>0 && valor<10){
         element.color="white"
       }
       if (valor>=10 && valor<15){
        element.color="yellow"
      }
      if (valor>=15 && valor<30){
        element.color="orange"
      }
      if (valor>=30){
        element.color="red"
      }
      if (element.venta<=0 && element.devolucion>0){
        element.color="red"
        element.porcentajeDevolucion=100
      }
    });
    this.totalVenta1=0;
    this.totalDevolucion1=0;
    this.datosVentas.forEach(element => {
      this.totalVenta1=this.totalVenta1+
      Number.parseFloat(element.venta.toString());
      this.totalDevolucion1=this.totalDevolucion1+
      Number.parseFloat(element.devolucion.toString());
     
      
    });
    this.datosVentas.sort((a,b)=> b.porcentajeDevolucion-a.porcentajeDevolucion);
    
    this.mdbTable.setDataSource(this.datosVentas);
    //this.mdbTablePagination.setMaxVisibleItemsNumberTo(1000)
    this.mdbTable.dataSourceChange();
  },
    err => this.alertService.danger('Error no hay  conexion..')
  )
}


listartipoCliente(){
  this.api.tipoCliente(this.id_pais).subscribe((
    data: []) => {
    this.tipo = data;
    console.log(this.tipo);
  },
    err => this.alertService.danger('Error no hay  conexion..')
  );
}
      


listarDevolucion() {
  let meses = "";
  let ani = "";
  let tipoDatos = "";
  let productos = "";
  this.totalVenta2=0;
  this.totalDevolucion2=0;
  this.totalPorDev2=0;
  this.meseSelec.forEach(element => {
    meses = meses + element + ",";
  });

  this.aniosselec.forEach(element => {
    ani = ani + element + ",";
  });

  this.tipoSelec.forEach(element => {
    tipoDatos = tipoDatos + "'"+element + "',";
  });


  if (meses.length > 0) {
    meses = meses + '0';
  } else {
    meses = "''"
  }

  if (ani.length > 0) {
    ani = ani + '0';
  } else {
    ani = "NO"
  }


  if (tipoDatos.length > 0) {
    tipoDatos = tipoDatos + "'0'"
  } else {
    tipoDatos = "NO"
  }

  this.api.DevolucionDesc(ani, meses, tipoDatos,localStorage.getItem("nombreLocal").substring(0,4),this.id_pais).subscribe((
    data: []) => {
    this.datosDevolucion = data;

    let porcentaje=0.0;  
    this.datosDevolucion.forEach(element => {
    if  (element.venta>0){
        porcentaje=(element.devolucion/element.venta)*100
      }else{
        porcentaje=0;
      }

     
      let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
       if (valor>0 && valor<10){
         element.color="white"
       }
       if (valor>=10 && valor<15){
        element.color="yellow"
      }
      if (valor>=15 && valor<30){
        element.color="orange"
      }
      if (valor>=30){
        element.color="red"
      }
      if (element.venta<=0 && element.devolucion>0){
        element.color="red"
        element.porcentajeDevolucion=100
      }


    });
    this.totalVenta2=0;
    this.totalDevolucion2=0;
    this.datosDevolucion.forEach(element => {
      this.totalVenta2=this.totalVenta2+
      Number.parseFloat(element.venta.toString());
      this.totalDevolucion2=this.totalDevolucion2+
      Number.parseFloat(element.devolucion.toString());
    });
    this.datosDevolucion.sort((a,b)=> a.porcentajeDevolucion-b.porcentajeDevolucion);
    this.mdbTableD.setDataSource(this.datosDevolucion);
   // this.mdbTablePaginationD.setMaxVisibleItemsNumberTo(20)
    this.mdbTableD.dataSourceChange();
  },
    err => this.alertService.danger('Error no hay  conexion..')
  );
}
}
